import { FORM_MODES } from '../constants/formModeConstants';
import { PIX_KEY_TYPE_VALUES } from '../constants/pixKeyTypeConstants';

export const mapToBankAccountBrPayload = (formValues) => {
  const isCnpj = formValues.formMode === FORM_MODES.CNPJ;
  const pixType = formValues.pixKeyType?.value;
  const pixKey =
    pixType === PIX_KEY_TYPE_VALUES.PHONE
      ? `+55${formValues.pixKey.replace(/\D/g, '')}`
      : formValues.pixKey;

  const accountData = {
    ...(isCnpj
      ? {
          cnpj: formValues.document,
          company_name: formValues.legalName,
          fiscal_address: formValues.fiscalAddress,
          cnae: formValues.cnae?.value,
        }
      : { cpf: formValues.document }),
    account_type: formValues.accountType.value,
    agency_code: formValues.agencyCode,
    account_number: formValues.accountNumber,
    pix_type: pixType,
    pix_key: pixKey,
  };

  return {
    account_document_type: isCnpj ? 'CNPJ' : 'CPF',
    id_bank: formValues.bank.value,
    account_data: accountData,
  };
};
